import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ANIMATION_DURATION_FADE_OUT, ANIMATION_DURATION_SLIDE } from './constants';
export var getDefaultStyleSheet = _ref => {
  var {
    animationState,
    designContext,
    disableAnimations,
    height,
    position,
    status
  } = _ref;
  var outerPaddingVertical = designContext.get('space/100').value();
  var outerPaddingHorizontal = designContext.get('space/200').value();
  var innerPadding = designContext.get('space/200').value();
  var gap = designContext.get('space/100').value();
  return {
    rootStyle: {
      backgroundColor: designContext.get('toast/background-color', {
        status
      }).toString(),
      borderRadius: designContext.get('toast/corner-radius').value(),
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      padding: innerPadding,
      gap
    },
    iconAndContentWrapperStyle: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      flexShrink: 1,
      gap
    },
    iconWrapperStyle: {
      flexShrink: 0
    },
    contentWrapperStyle: {
      flexShrink: 1,
      gap
    },
    linkAndCloseIconWrapperStyle: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap
    },
    portalStyle: _objectSpread(_objectSpread({
      opacity: [undefined, 'fade-out'].includes(animationState) ? 0 : 1,
      // DialogUnwrapped has zIndex 2147483647,
      // so we need to use the same here in order to have the Toast rendered on top of it
      zIndex: 2147483647,
      position: 'fixed'
    }, height ? {
      ["".concat(position)]: [undefined, 'slide-out'].includes(animationState) ? -height : outerPaddingVertical
    } : {}), {}, {
      transition: disableAnimations ? undefined : [undefined, 'slide-in'].includes(animationState) ? "".concat(position, " ").concat(ANIMATION_DURATION_SLIDE, "ms") : "".concat(position, " ").concat(ANIMATION_DURATION_SLIDE, "ms, opacity ").concat(ANIMATION_DURATION_FADE_OUT, "ms"),
      left: outerPaddingHorizontal,
      right: outerPaddingHorizontal
    })
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map